export const marketplaceIncomingOrdersTour = {
  tourKey: 'marketplace_incoming_orders',
  conditions: {
    orgTypes: ['npo', 'business'],
    userTypes: ['admin', 'staff'],
    plans: null,
  },
  steps: [
    {
      // No target - centered welcome popover
      title: 'tours.marketplace-incoming-orders.welcome.title',
      content: 'tours.marketplace-incoming-orders.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="marketplace-orders-tabs"]',
      title: 'tours.marketplace-incoming-orders.tabs.title',
      content: 'tours.marketplace-incoming-orders.tabs.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="marketplace-orders-list"]',
      title: 'tours.marketplace-incoming-orders.move-forward.title',
      content: 'tours.marketplace-incoming-orders.move-forward.content',
      placement: 'top',
    },
    {
      target: '[data-tour="marketplace-orders-list"]',
      title: 'tours.marketplace-incoming-orders.adjust.title',
      content: 'tours.marketplace-incoming-orders.adjust.content',
      placement: 'top',
    },
  ],
};
